import { ReactComponent as Facebook } from "@/assets/icons/facebook.svg";
import { ReactComponent as IconNovaventa } from "@/assets/icons/iconNovaventa.svg";
import { ReactComponent as IconNutresa } from "@/assets/icons/iconNutresa.svg";
import { ReactComponent as Instagram } from "@/assets/icons/instagram.svg";
import { ReactComponent as Laptop } from "@/assets/icons/laptop.svg";
import { ReactComponent as LinkedIn } from "@/assets/icons/linkedin.svg";
import { ReactComponent as Shield } from "@/assets/icons/shield.svg";
import { ReactComponent as Twitter } from "@/assets/icons/twitter.svg";
import { ReactComponent as Users } from "@/assets/icons/users.svg";
import { ReactComponent as YouTube } from "@/assets/icons/youtube.svg";
import { ReactComponent as LogoNovaventa } from "@/assets/img/logoNovaventaHeader.svg";
import theme from "@/styles/novaTheme";

type IconAppProps = {
  name: string;
  fontSize?: number | string;
  width?: number;
  height?: number;
  color?: keyof typeof theme.colors | "primary";
};

const iconsMap = {
  logoNovaventa: LogoNovaventa,
  iconNovaventa: IconNovaventa,
  iconNutresa: IconNutresa,
  laptop: Laptop,
  users: Users,
  shield: Shield,
  facebook: Facebook,
  twitter: Twitter,
  youtube: YouTube,
  instagram: Instagram,
  linkedin: LinkedIn
};

export const IconApp = ({ name, ...style }: IconAppProps) => {
  if (style.color === "primary") {
    style.color = theme.colors.blue400 as any;
  } else if (style.color && Object.keys(theme.colors).includes(style.color)) {
    style.color = theme.colors[style.color] as any;
  }

  const IconComponent = iconsMap[name as keyof typeof iconsMap];

  return IconComponent ? <IconComponent style={style} /> : <></>;
};
